var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 88C19.7 88 0 68.3 0 44S19.7 0 44 0s44 19.7 44 44-19.7 44-44 44m0-85C21.4 3 3 21.4 3 44s18.4 41 41 41 41-18.4 41-41S66.6 3 44 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27.4 28.6 58.6H33l11-22.2 11 22.2h4.4z"
  })));
};
export default SvgLogin;